import { Outlet } from "react-router-dom";
import { ROUTE_BASENAME } from "../constants";
import { addSlashAtEnd } from "../lib/helpers/utils";

export const PATH = addSlashAtEnd(ROUTE_BASENAME);

export default function Root() {
	return (
		<div id="root-route-component">
			<Outlet />
		</div>
	);
}
